import { useEffect } from 'react';

import { useBoolean } from '@trend-dev/ui-libs-utils/hooks/useBoolean';
import { useUpdatedRef } from '@trend-dev/ui-libs-utils/hooks/useUpdatedRef';

import { useSizeStore } from 'store/size';

import { useSendErrorMetrics } from 'YM/hooks/useErrorMetrics';

/**
 * Хук для работы с Fullscreen Api
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
 * */
export function useFullScreenApi() {
    const { isFull, setIsFull } = useSizeStore();
    const [isFullscreenCanBeChecked, { on: setIsFullscreenCanBeChecked }] = useBoolean(false);
    const { current: isFullscreenCanBeCheckedRef } = useUpdatedRef(isFullscreenCanBeChecked);
    const sendErrorMetrics = useSendErrorMetrics();
    const sendErrorMetricsRef = useUpdatedRef(sendErrorMetrics);

    useEffect(() => {
        if (isFullscreenCanBeCheckedRef) {
            if (isFull) {
                try {
                    document.documentElement.requestFullscreen();
                } catch (error) {
                    sendErrorMetricsRef.current({ data: error, name: 'Вход в fullscreen режим' });
                }
            } else {
                try {
                    document.exitFullscreen();
                } catch (error) {
                    sendErrorMetricsRef.current({ data: error, name: 'Выход из fullscreen режима' });
                }
            }
        } else {
            setIsFullscreenCanBeChecked();
        }
    }, [isFull]);

    // пользователь выходит из состояния fullscreen при помощи браузерного интерфейса
    useEffect(() => {
        function listener() {
            if (!document.fullscreenElement) {
                setIsFull(false);
            }
        }
        document.addEventListener('fullscreenchange', listener);

        return () => {
            document.removeEventListener('fullscreenchange', listener);
        };
    }, []);
}
